// components/aside/MobileAside.js
import React, { useState, useEffect, startTransition } from "react";
import "./MobileAside.css";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { setLoginData } from "../../redux/slices/userSlice";
import { downloadOrders } from "../../axios/api/downloadOrders";
import { MdSpaceDashboard } from "react-icons/md";
import { FaClipboardList } from "react-icons/fa";
import { HiShoppingBag, HiDownload } from "react-icons/hi";
import { BsBarChartLineFill } from "react-icons/bs";
import { IoCalendar } from "react-icons/io5";
import { BsBank2 } from "react-icons/bs";
import { CgMenuRightAlt } from "react-icons/cg";
import { FaTimes } from "react-icons/fa";

const MobileAside = ({ onClose, isOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeItemId, setActiveItemId] = useState("/dashboard");
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  const lang = location.pathname.split("/")[1] || "am";

  useEffect(() => {
    setActiveItemId(location.pathname);
  }, [location.pathname]);

  const handleClick = (item) => {
    if (item === "/") {
      setLoginData(false);
      localStorage.removeItem("userPartnerData");

      startTransition(() => {
        navigate(`/${lang}`);
      });

      return;
    }

    setActiveItemId(item);

    startTransition(() => {
      navigate(`/${lang}${item}`);
    });

    setIsMoreOpen(false);
  };

  const icons = [
    {
      id: 1,
      section: t("dashboard"),
      path: "/dashboard",
      svg: <MdSpaceDashboard className="w-full h-8 relative z-20" />,
    },
    {
      id: 2,
      section: t("services"),
      path: "/services",
      svg: <FaClipboardList className="w-full h-8 relative z-20 mb-[5px]" />,
    },
    {
      id: 3,
      section: t("orders"),
      path: "/orders",
      svg: <HiShoppingBag className="w-full h-9 relative z-20" />,
    },
    {
      id: 4,
      section: t("statistics"),
      path: "/statistics",
      svg: <BsBarChartLineFill className="w-6 h-6" />,
    },
    {
      id: 5,
      section: t("calendar"),
      path: "/calendar",
      svg: <IoCalendar className="w-6 h-6" />,
    },
    {
      id: 7,
      section: t("finances"),
      path: "/finances",
      svg: <BsBank2 className="w-6 h-6" />,
    },
  ];

  const leftIcons = icons.filter(
    (item) => item.path === "/dashboard" || item.path === "/services",
  );

  const rightIcons = icons.filter((item) => item.path === "/orders");

  const moreIcons = icons.filter(
    (item) => !["/dashboard", "/services", "/orders"].includes(item.path),
  );

  const onDownloadClick = async () => {
    try {
      const response = await downloadOrders();

      if (!response?.data?.download_url) {
        throw new Error("No download URL found");
      }

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
        today.getMonth() + 1,
      ).padStart(2, "0")}-${today.getFullYear()}`;

      const fileName = `${t("orders")}_${formattedDate}.csv`;

      const fileRes = await fetch(response.data.download_url);
      const blob = await fileRes.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      <div
        className="mobile-bottom-menu"
        style={{
          backgroundImage: `url(/assets/bottomMenuBG.png)`,
          filter: "drop-shadow(0px 3px 5px #000)",
        }}
      >
        <div className="bottom-menu-wrapper">
          {/* LEFT */}
          <div className="menu-group menu-group-left">
            {leftIcons.map((item) => (
              <div key={item.id} onClick={() => handleClick(item.path)}>
                {item.svg}
                <h5 className="tab-menu-headline">{item.section}</h5>
              </div>
            ))}
          </div>

          {/* CENTER BUTTON */}
          <button
            className="plusBtn block-background-design dark:bg-[#0d0d0d] !border-[5px] !border-primary"
            onClick={onDownloadClick}
          >
            <HiDownload className="text-primary" />
          </button>

          {/* RIGHT */}
          <div className="menu-group menu-group-right">
            {rightIcons.map((item) => (
              <div key={item.id} onClick={() => handleClick(item.path)}>
                {item.svg}
                <h5 className="tab-menu-headline">{item.section}</h5>
              </div>
            ))}

            {/* MORE */}
            <div onClick={() => setIsMoreOpen(!isMoreOpen)}>
              {isMoreOpen ? (
                <FaTimes className="w-full h-9" />
              ) : (
                <CgMenuRightAlt className="w-full h-9" />
              )}
              <h5 className="tab-menu-headline">{t("more")}</h5>
            </div>
          </div>
        </div>
      </div>

      {/* MORE MENU POPUP */}
      {isMoreOpen && (
        <div className="more-menu">
          {moreIcons.map((item) => (
            <div
              key={item.id}
              className="more-menu-item"
              onClick={() => handleClick(item.path)}
            >
              {item.svg}
              <span>{item.section}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MobileAside;
